<template>
  <section class="content">
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
        >
          <router-link :to="{ name: 'DeviceCreate' }">
            <button class="btn ">Add New</button>
          </router-link>
        </div>
        <v-server-table
          ref="deviceTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit" 
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';

import moment from 'moment';
export default {
  name: 'Device',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: null,
      deviceTable: null,
      columns: ['deviceId', 'device_model', 'imei', 'connectionId', 'dateAdded', 'status'],
      options: {
        highlightMatches: true,
        sortable: [
          'deviceId',
          'brand',
          'deviceModel',
          'imei',
          'connectionId',
          'dateAdded',
          'status',
        ],
        headings: {
          deviceId: 'Device Id',
          device_model: 'Device Model',
          imei: 'IMEI',
          connectionId: 'Connection ID',
          dateAdded: 'Registration Date',
          status: 'Status',
        },

        templates: {
          device_model(row, query) {
            return `${query.brand.toUpperCase()} - ${query.deviceModel.toUpperCase()}`;
          },

          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },

          dateAdded(row, query) {
            return moment(query.dateAdded).format('DD-MM-YYYY');
          },
        },

        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          }
          // else {
          //   params.$sort = 'dateAdded';
          // }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$deviceDataRepository.list(params).catch(error => {
            console.error('Device.requestFunction-error:', error);
            this.$snotify.error('Get Device', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.deviceTable) {
        return this.deviceTable.count > this.deviceTable.limit ||
          this.deviceTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'DeviceDetail',
        params: { _id: data.row._id },
        props: data.row,
      });
    },
    onLoaded() {
      this.deviceTable = this.$refs.deviceTable;
    },
  },
};
</script>
<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.btn {
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white
}
</style>



// WEBPACK FOOTER //
// Devices.vue?40ac720e